import { useEffect, useRef, useState } from "react";
import { MapPin, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { Input } from "./ui/input";

export default function AddressSearch({ value, onChange, onPick, testId = "address-search" }) {
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const skip = useRef(false);

  useEffect(() => {
    if (skip.current) { skip.current = false; return undefined; }
    if (!value || value.trim().length < 3) { setResults([]); return undefined; }
    const t = setTimeout(async () => {
      setLoading(true);
      try { const { data } = await api.get("/geo/search", { params: { q: value } }); setResults(data); setOpen(true); } catch { setResults([]); } finally { setLoading(false); }
    }, 450);
    return () => clearTimeout(t);
  }, [value]);

  const pick = (r) => {
    skip.current = true;
    onPick(r);
    setOpen(false);
    setResults([]);
  };

  return (
    <div className="relative">
      <MapPin className="absolute left-3 top-3 h-4 w-4 text-slate-400" />
      <Input value={value} onChange={(e) => onChange(e.target.value)} onFocus={() => results.length && setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)}
        placeholder="Start typing address or postcode…" className="pl-9 h-11" autoComplete="off" data-testid={`${testId}-input`} />
      {loading && <Loader2 className="absolute right-3 top-3 h-4 w-4 animate-spin text-slate-400" />}
      {open && results.length > 0 && (
        <ul className="absolute z-20 mt-1 w-full bg-white border border-slate-200 rounded-lg shadow-lg max-h-64 overflow-auto" data-testid={`${testId}-results`}>
          {results.map((r, i) => (
            <li key={`${r.source}-${i}`}>
              <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => pick(r)} className="w-full text-left px-3 py-2.5 hover:bg-slate-50 active:bg-slate-100" data-testid={`${testId}-result-${i}`}>
                <span className="block text-sm font-medium text-slate-900">{r.address}</span>
                <span className="block text-xs text-slate-500 truncate">{r.label}</span>
              </button>
            </li>
          ))}
          <li className="px-3 py-1.5 text-[10px] text-slate-400 border-t border-slate-100">© OpenStreetMap contributors · postcodes.io</li>
        </ul>
      )}
    </div>
  );
}
